import { Flex as SemFlex } from '@semcore/ui/flex-box';

export const Flex = SemFlex;
